import { io } from "socket.io-client";
import { BaseURL } from "../Utils/interceptors";
import store from "../Redux/store";
import {
  playNotificationSound,
  setupNotificationAudioUnlockOnFirstInteraction,
} from "./notificationSound";

let socket = null;

const socketServerUrl = BaseURL.replace(/\/api\/?$/, "");

export const connectWithSocketServer = (userDetails, audio) => {
  if (audio) {
    const body = document.querySelector("body");
    if (body && !body.contains(audio)) {
      body.appendChild(audio);
    }
    setupNotificationAudioUnlockOnFirstInteraction(audio);
  }

  const jwtToken = userDetails?.token;
  const userChannel = "notification-" + userDetails.employee._id;

  if (socket?.connected) {
    socket.disconnect();
  }

  socket = io(socketServerUrl, {
    auth: {
      token: jwtToken,
    },
  });

  socket.on("connect", () => {});

  socket.on(userChannel, (data) => {
    playNotificationSound(audio);
    store.dispatch({
      type: "UPDATE_ALL_NOTIFICATIONS_SUCCESS",
      payload: {
        notification: [
          data.newData,
          ...store.getState().employeeNotifications.notifications,
        ],
        count: store.getState().employeeNotifications.count + 1,
      },
    });
  });
};

export const newLeaveSubmitted = (data) => {
  socket.emit("notification", data);
};

export const logoutUserConnection = (data) => {
  socket.emit("logout", data?.employee?._id);
};
